import withModal from '../../../../../../components/global/modal/withModal';
import AddressBookCSVUpload from './AddressBookCSVUpload';

export const ADDRESS_BOOOK_CSV_UPLOAD_MODAL = 'ADDRESS_BOOOK_CSV_UPLOAD_MODAL';

const AddressBookCSVUploadModal = withModal(AddressBookCSVUpload, {
  name: ADDRESS_BOOOK_CSV_UPLOAD_MODAL,
  size: 'xl',
  hideHeader: true,
  shouldCloseOnOverlayClick: false,
});

export default AddressBookCSVUploadModal;
